<template>
  <router-view />
</template>

<script>

export default {
  name: 'App',
}
</script>

<style>
body {
  margin:0px;
  background-image:none;
  position:relative;
  left:-0px;
  width:1000px;
  margin-left:auto;
  margin-right:auto;
  text-align:left;
}
</style>
